import { useEffect } from "react";
import { Link } from "react-router-dom";
import * as MUI from "@mui/material";
import * as UIcons from "@mui/icons-material";
import { IoPeopleSharp, IoStatsChart } from "react-icons/io5";
import { IoMdExit } from "react-icons/io";
import { AiOutlineFileSearch } from "react-icons/ai";
import { FaBicycle, FaFileDownload, FaUserSecret, FaCar } from "react-icons/fa";
import { MdPhoneIphone } from "react-icons/md";
import { GiHandcuffs } from "react-icons/gi";
import { HiOutlineIdentification } from "react-icons/hi";

import { FormDialog } from "../../components/Dialog";

import {
  celularStoreImei,
  celularStoreNome,
  bikeStore,
  veiculoStorePlaca,
  veiculoStoreChassi,
  civilStoreNominal,
  civilStoreCPF,
  civilStoreRG,
  criminalStoreNominal,
  criminalStoreCPF,
  carcerarioStoreNominal,
  carcerarioStoreRG,
  mandadoStoreNominal,
} from "../../hooks/store";
import { useAuth } from "../../hooks/auth";

export const Home: React.FC = () => {
  const { user, logout } = useAuth();

  const sistema = user?.sistemas?.map((sistemas) => sistemas.id_sistema);
  const acesso = user?.tipo_acesso.id_acesso;

  const semSistemas = !user?.sistemas || user.sistemas.length < 1;

  const alerta = sistema?.find((r) => r === 1);
  const civil = sistema?.find((r) => r === 2);
  const mandado = sistema?.find((r) => r === 3);
  const carcerario = sistema?.find((r) => r === 4);
  const boepmOme = sistema?.find((r) => r === 5);
  const veiculo = sistema?.find((r) => r === 8);
  const criminal = sistema?.find((r) => r === 9);
  const boepmGeral = sistema?.find((r) => r === 10);
  const boepmUsuario = sistema?.find((r) => r === 7);

  const { limparConsultaCelularImei } = celularStoreImei(
    (state) => state.celular
  );

  const { limparConsultaCelularNome } = celularStoreNome(
    (state) => state.celular
  );
  const { limparConsultaVeiculoPlaca } = veiculoStorePlaca(
    (state) => state.veiculo
  );
  const { limparConsultaVeiculoChassi } = veiculoStoreChassi(
    (state) => state.veiculo
  );
  const { limparConsultaBike } = bikeStore((state) => state.bike);
  const { limparConsultaCivilRg } = civilStoreRG((state) => state.civil);
  const { limparConsultaCivilCPF } = civilStoreCPF((state) => state.civil);
  const { limparConsultaCivilNominal } = civilStoreNominal(
    (state) => state.civil
  );
  const { limparConsultaCriminalNominal } = criminalStoreNominal(
    (state) => state.criminal
  );
  const { limparConsultaCriminalCPF } = criminalStoreCPF(
    (state) => state.criminal
  );
  const { limparConsultaCarcerarioNominal } = carcerarioStoreNominal(
    (state) => state.carcerario
  );
  const { limparConsultaCarcerarioRG } = carcerarioStoreRG(
    (state) => state.carcerario
  );
  const { limparConsultaMandadoNominal } = mandadoStoreNominal(
    (state) => state.mandado
  );

  useEffect(() => {
    limparConsultaCelularImei();
    limparConsultaCelularNome();
    limparConsultaVeiculoPlaca();
    limparConsultaVeiculoChassi();
    limparConsultaBike();
    limparConsultaCivilRg();
    limparConsultaCivilCPF();
    limparConsultaCivilNominal();
    limparConsultaCriminalNominal();
    limparConsultaCriminalCPF();
    limparConsultaCarcerarioNominal();
    limparConsultaCarcerarioRG();
    limparConsultaMandadoNominal();
  }, []);

  return (
    <MUI.Stack
      minHeight={["66vh", "60.2vh", "60.2vh", "60.2vh", "73.4vh"]}
      height="100%"
      flexDirection={["column", "row", "row"]}
      width="100%"
      my={[3, 0, 0]}
    >
      {user?.grupo === 1 && user.primeiro_acesso === 0 ? (
        <div style={{ display: "none" }}>
          <FormDialog />
        </div>
      ) : (
        false
      )}
      <MUI.Stack
        textAlign="center"
        flexBasis="84%"
        flexDirection="row"
        justifyContent={["center", "inherit"]}
        flexWrap="wrap"
        gap={2.5}
        padding={2}
      >
        {semSistemas ? (
          <MUI.Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
              p: 4,
              borderRadius: 3,
              border: "1.5px solid",
              borderColor: "#e0e0e0",
              backgroundColor: "#faf3b3",
              maxWidth: 480,
              mt: 2,
            }}
          >
            <UIcons.WarningAmberRounded
              sx={{ fontSize: "2rem", color: "#757575" }}
            />
            <MUI.Typography
              variant="h6"
              fontWeight="bold"
              color="text.primary"
              textAlign="center"
            >
              Nenhum sistema associado
            </MUI.Typography>
            <MUI.Typography
              variant="body2"
              color="text.primary"
              textAlign="center"
            >
              Seu usuário não possui sistemas associados. Por favor, entre em
              contato com o seu <strong>Administrador</strong> para
              regularização do acesso.
            </MUI.Typography>
          </MUI.Box>
        ) : (
          <MUI.Paper
            component={Link}
            elevation={6}
            to="/consultas-integradas"
            sx={{
              display: "flex",
              flexDirection: "column",
              width: 286,
              height: 160,
              alignItems: "center",
              paddingTop: 3,
              gap: 1,
              textDecoration: "none",
            }}
          >
            <MUI.Typography
              variant="button"
              sx={{
                fontWeight: "bold",
              }}
            >
              Consultas Integradas
            </MUI.Typography>
            <UIcons.Dvr
              sx={{
                width: "5rem",
                height: "5rem",
              }}
            />
          </MUI.Paper>
        )}

        {civil === 2 && (
          <MUI.Paper
            component={Link}
            elevation={6}
            to="/consulta-civil-pesquisa-nominal"
            sx={{
              display: "flex",
              flexDirection: "column",
              width: 286,
              height: 160,
              alignItems: "center",
              paddingTop: 3,
              gap: 1,
              textDecoration: "none",
            }}
          >
            <MUI.Typography
              variant="button"
              sx={{
                fontWeight: "bold",
              }}
            >
              Consulta Civil
            </MUI.Typography>
            <HiOutlineIdentification size="5.5rem" />
          </MUI.Paper>
        )}

        {criminal === 9 && (
          <MUI.Paper
            component={Link}
            elevation={6}
            to="/consulta-criminal-pesquisa-nominal"
            sx={{
              display: "flex",
              flexDirection: "column",
              width: 286,
              height: 160,
              alignItems: "center",
              paddingTop: 3,
              gap: 1,
              textDecoration: "none",
            }}
          >
            <MUI.Typography
              variant="button"
              sx={{
                fontWeight: "bold",
              }}
            >
              Consulta Criminal
            </MUI.Typography>
            <FaUserSecret size="4rem" />
          </MUI.Paper>
        )}

        {carcerario === 4 && (
          <MUI.Paper
            component={Link}
            elevation={6}
            to="/consulta-carcerario-nominal"
            sx={{
              display: "flex",
              flexDirection: "column",
              width: 286,
              height: 160,
              alignItems: "center",
              paddingTop: 3,
              gap: 1,
              textDecoration: "none",
            }}
          >
            <MUI.Typography
              variant="button"
              sx={{
                fontWeight: "bold",
              }}
            >
              Consulta Carcerária
            </MUI.Typography>
            <GiHandcuffs size="4.5rem" />
          </MUI.Paper>
        )}

        {mandado === 3 && (
          <MUI.Paper
            component={Link}
            elevation={6}
            // to="/consulta-mandado-pesquisa-nominal"
            to="/consulta-mandado-facial"
            sx={{
              display: "flex",
              flexDirection: "column",
              width: 286,
              height: 160,
              alignItems: "center",
              paddingTop: 3,
              gap: 1,
              textDecoration: "none",
            }}
          >
            <MUI.Typography
              variant="button"
              sx={{
                fontWeight: "bold",
              }}
            >
              Consulta Mandado
            </MUI.Typography>
            <AiOutlineFileSearch size="4.5rem" />
          </MUI.Paper>
        )}

        {alerta === 1 && (
          <MUI.Paper
            component={Link}
            elevation={6}
            to="/alerta/consulta-celular"
            sx={{
              display: "flex",
              flexDirection: "column",
              width: 286,
              height: 160,
              alignItems: "center",
              paddingTop: 3,
              gap: 1,
              textDecoration: "none",
            }}
          >
            <MUI.Typography
              variant="button"
              sx={{
                fontWeight: "bold",
              }}
            >
              Consulta Celular
            </MUI.Typography>
            <MdPhoneIphone size="4rem" />
          </MUI.Paper>
        )}

        {alerta === 1 && (
          <MUI.Paper
            component={Link}
            elevation={6}
            to="/alerta/consulta-bike"
            sx={{
              display: "flex",
              flexDirection: "column",
              width: 286,
              height: 160,
              alignItems: "center",
              paddingTop: 3,
              gap: 1,
              textDecoration: "none",
            }}
          >
            <MUI.Typography
              variant="button"
              sx={{
                fontWeight: "bold",
              }}
            >
              Consulta Bike
            </MUI.Typography>
            <FaBicycle size="4rem" />
          </MUI.Paper>
        )}

        {veiculo === 8 && (
          <MUI.Paper
            component={Link}
            elevation={6}
            to="/consulta-veiculo/consulta-placa"
            sx={{
              display: "flex",
              flexDirection: "column",
              width: 286,
              height: 160,
              alignItems: "center",
              paddingTop: 3,
              gap: 1,
              textDecoration: "none",
            }}
          >
            <MUI.Typography
              variant="button"
              sx={{
                fontWeight: "bold",
              }}
            >
              Consulta Veículo
            </MUI.Typography>
            <FaCar size="5rem" />
          </MUI.Paper>
        )}

        {user?.base === "pm" ||
        boepmUsuario === 7 ||
        boepmOme === 5 ||
        boepmGeral === 10 ||
        acesso === "2" ? (
          <MUI.Paper
            component={Link}
            elevation={6}
            to="/boepm/bos-do-usuario-ocorrencia"
            sx={{
              display: "flex",
              flexDirection: "column",
              width: 286,
              height: 160,
              alignItems: "center",
              paddingTop: 3,
              gap: 1,
              textDecoration: "none",
            }}
          >
            <MUI.Typography
              variant="button"
              sx={{
                fontWeight: "bold",
              }}
            >
              Consulta BOEPM
            </MUI.Typography>
            <IoStatsChart size="5rem" />
          </MUI.Paper>
        ) : (
          false
        )}
      </MUI.Stack>

      <MUI.Stack
        flexBasis="16%"
        textAlign="center"
        alignItems="center"
        p={2}
        gap={2.5}
      >
        {acesso === "1" || acesso === "2" ? (
          <MUI.Paper
            component={Link}
            elevation={6}
            to="/gerenciamentodeusuario/lista-usuario"
            sx={{
              display: "flex",
              width: 286,
              height: 50,
              alignItems: "center",
              justifyContent: "center",
              px: 1,
              textDecoration: "none",
            }}
          >
            <IoPeopleSharp size="2.5rem" color="#ffcb02" />
            <MUI.Typography variant="body2" width="100%" fontWeight="bold">
              Gerenciamento de usuário
            </MUI.Typography>
          </MUI.Paper>
        ) : (
          false
        )}

        {/*
        <MUI.Paper
          component="a"
          href="https://drive.google.com/file/d/1oPYAz_5ZMSgdDfx7NAFZthWhqZvxYRFd/view"
          target="_blank"
          rel="noreferrer noopener"
          elevation={6}
          sx={{
            display: "flex",
            width: 286,
            height: 50,
            alignItems: "center",
            justifyContent: "center",
            px: 1,
            textDecoration: "none",
          }}
        >
          <FaFileDownload size="2.5rem" color="#049934" />
          <MUI.Typography variant="body2" width="100%" fontWeight="bold">
            Download do APP
          </MUI.Typography>
        </MUI.Paper>
        */}

        <MUI.Paper
          elevation={6}
          onClick={logout}
          sx={{
            display: "flex",
            width: 286,
            height: 50,
            alignItems: "center",
            justifyContent: "center",
            px: 1,
            cursor: "pointer",
          }}
        >
          <IoMdExit size="2.5rem" color="#ff1301" />
          <MUI.Typography variant="body2" width="100%" fontWeight="bold">
            Sair do sistema
          </MUI.Typography>
        </MUI.Paper>
      </MUI.Stack>
    </MUI.Stack>
  );
};

export default Home;
